// Safe fetch wrapper that handles non-JSON responses gracefully

export async function safeFetch(url, options = {}) {
  const res = await fetch(url, options);
  if (res.ok) {
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      return await res.json();
    }
    return await res.text();
  }

  // Error response
  let errorMsg = `Server error (${res.status})`;
  try {
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      const data = await res.json();
      errorMsg = data.detail || data.error || data.message || errorMsg;
    } else {
      const text = await res.text();
      if (text.includes('<!DOCTYPE') || text.includes('<html')) {
        const titleMatch = text.match(/<title>([^<]+)<\/title>/);
        errorMsg = titleMatch ? `${titleMatch[1].trim()} (${res.status})` : `Server unavailable (${res.status})`;
      } else if (text.length < 500) {
        errorMsg = text || errorMsg;
      }
    }
  } catch {}
  const err = new Error(errorMsg);
  err.status = res.status;
  throw err;
}

// JSON-only variant for APIs that should return JSON
export async function fetchJson(url, options = {}) {
  return await safeFetch(url, options);
}
